import { render, staticRenderFns } from "./FileDeleteButton.vue?vue&type=template&id=223b9ca8&scoped=true&lang=html"
import script from "./FileDeleteButton.vue?vue&type=script&lang=js"
export * from "./FileDeleteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223b9ca8",
  null
  
)

export default component.exports